export default __webpack_public_path__ + "static/media/belize-flag.6cb5fd37.png";